import styled from "@emotion/styled";

const StyledFooter = styled("footer")({
    "& h6": { fontSize: "12px" },
    marginBlock: "16px",
    width: "100%",
});

export default StyledFooter;
